import React, { ComponentProps } from 'react'

import { Button } from '@zet/design-system/button'

interface Props {
  step?: {
    total: number
    current: number
  }
  buttonProps?: ComponentProps<typeof Button>
}

const NonFormButton = (props: Props) => {
  const { buttonProps, step } = props

  return (
    <Button
      size="lg"
      disabled={buttonProps?.disabled}
      fullWidth
      onPress={buttonProps?.onPress}
      loading={buttonProps?.loading}
    >
      {step?.current === step?.total ? 'Submit' : 'Continue'}
    </Button>
  )
}

export default NonFormButton
